"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base64Encode = (obj) => {
    if (typeof window !== "undefined") {
        return window.btoa(obj);
    }
    return Buffer.from(obj).toString("base64");
};
exports.default = base64Encode;
